import React from 'react';

const ProCollegeButtons = ({
	selectedPlayingLevelType,
	handleProStatsButtonClick,
	handleCollegeStatsButtonClick,
}) => {
	return (
		<div className="mb-4 flex flex-row">
			{/* NFL Button */}
			<div className="items-center" onClick={handleProStatsButtonClick}>
				<button
					className={`p-2 border border-gray-300 dark:border-dark-border ${
						selectedPlayingLevelType === 'pro'
							? 'bg-gray-800 dark:bg-gray-700 text-white'
							: 'bg-white dark:bg-dark-card text-black dark:text-dark-text'
					} rounded-l-lg border-r-0`}
				>
					NFL Stats
				</button>
			</div>
			{/* College Button */}
			<div className="items-center" onClick={handleCollegeStatsButtonClick}>
				<button
					className={`p-2 border border-gray-300 dark:border-dark-border ${
						selectedPlayingLevelType === 'college'
							? 'bg-gray-800 dark:bg-gray-700 text-white'
							: 'bg-white dark:bg-dark-card text-black dark:text-dark-text'
					} rounded-r-lg border-l-0`}
				>
					College Stats
				</button>
			</div>
		</div>
	);
};

export default ProCollegeButtons;
